import React, { createContext, useState, useEffect } from 'react';
import {
  getCart,
  setCart,
  clearCart,
  addItemToCart,
  removeItemFromCart,
  updateItemQuantity,
  removeExpiredItems,
  getTotalItems,
} from '../utils/sessionStorage';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCartState] = useState(getCart());

  useEffect(() => {
    const interval = setInterval(() => {
      removeExpiredItems();
      setCartState(getCart());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const addToCart = (item) => {
    addItemToCart(item);
    setCartState(getCart());
  };

  const removeFromCart = (id, color, size) => {
    removeItemFromCart(id, color, size);
    setCartState(getCart());
  };

  const updateQuantity = (id, color, size, quantity) => {
    updateItemQuantity(id, color, size, quantity);
    setCartState(getCart());
  };

  const clearAll = () => {
    clearCart();
    setCartState([]);
  };

  const cartSummary = cart.reduce((acc, item) => {
    acc.totalItems += item.quantity;
    acc.subTotal += item.price * item.quantity;
    return acc;
  }, { totalItems: 0, subTotal: 0 });

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearAll, cartSummary }}>
      {children}
    </CartContext.Provider>
  );
};
